/**
 * MMAGuy — open the product page on the size that is ON THE SHELF.
 *
 * MMAGUY-PDP-LINES-2026-09-05
 *
 * `selected_or_first_available_variant` picks the first variant Shopify can
 * SELL, and 620 variants on this store are sellable at qty 0 (sourced-to-order
 * under CONTINUE). So a glove whose only pair on the shelf is 14oz opened on
 * 8oz and printed a 3-5 day wait — on gear a local buyer could collect within
 * the hour. Measured 2026-09-05: 38 products, 36 of them with exactly one size
 * in the shop.
 *
 * Liquid cannot change that selection, so the split is:
 *   SERVER decides  — blocks/mmaguy-ships-note.liquid emits data-preselect ONLY
 *                     when the selected size is off-shelf and another is on it.
 *   CLIENT obeys    — this file clicks that size, once, and nothing else.
 *
 * ⚠ data-preselect does NOT clear itself after the switch — mmaguy-ships-note.js
 * morphs childrenOnly, so host attributes are never refreshed (verified live
 * 2026-09-06). Loop safety comes from the two guards below and nothing else:
 *   1. a once-per-load window flag, set BEFORE the click;
 *   2. an early return when the target control is already selected.
 * Keep both. It is also a no-op if the shopper arrived on a deliberate ?variant=
 * link, if the control is missing, or if anything at all is unexpected.
 * All 38 affected products are single-option (Size / SIZE / Oz), verified live.
 */
const DONE = 'mmaguyShelfSizeHandled';

function preselect() {
  try {
    // A ?variant= URL is an explicit choice — a share link, an ad, a back
    // button. Never override the shopper.
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (window[DONE]) return;

    const host = document.querySelector('mmaguy-ships-note[data-preselect]');
    if (!host) return;
    const want = host.dataset.preselect;
    if (!want) return;

    const scope = host.closest('.shopify-section') || document;

    // Radio picker (the common case on this store).
    const radios = scope.querySelectorAll('input[type="radio"]');
    for (const r of radios) {
      if (r.value === want) {
        if (r.checked || r.getAttribute('aria-disabled') === 'true') return;
        window[DONE] = true;
        r.click();
        return;
      }
    }

    // Dropdown picker fallback.
    const select = scope.querySelector('select.variant-option__select');
    if (select) {
      for (const opt of select.options) {
        if (opt.value === want) {
          if (select.value === want) return;
          window[DONE] = true;
          select.value = want;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
  } catch (e) {
    // A merchandising nicety must never break a buy button.
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', preselect, { once: true });
} else {
  preselect();
}
